import { cn } from '@/core/lib/utils';

interface ResizeHandleProps {
  onMouseDown: (e: React.MouseEvent) => void;
  className?: string;
}

/**
 * Atomic component for tree view resize handle
 */
export function ResizeHandle({ onMouseDown, className }: ResizeHandleProps) {
  return (
    <div 
      className={cn(
        "absolute top-0 right-0 w-3 h-full cursor-col-resize hover:bg-blue-100 active:bg-blue-200 transition-colors flex items-center justify-center group z-10",
        className
      )}
      onMouseDown={onMouseDown}
      title="Drag to resize tree panel"
      style={{ right: '-6px' }}
    >
      <div className="w-1 h-12 bg-gray-400 group-hover:bg-blue-500 group-active:bg-blue-600 transition-colors rounded-full shadow-sm" />
    </div>
  );
}